import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'helpers/no_conflict_lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faAngleDown } from '@fortawesome/pro-solid-svg-icons';


export class MobileFilterTopBar extends React.Component {
  static propTypes = {
    assetClasses: PropTypes.array.isRequired,
    availabilities: PropTypes.array.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    saleFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedGroupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tags: PropTypes.array.isRequired,
    onDisplayFilters: PropTypes.func.isRequired,
  };

  isSelected(selected, value) {
    return _.includes(selected || [], value);
  }

  appliedFilters() {
    const {
      assetClasses,
      availabilities,
      selectedAssetClasses,
      selectedAvailabilities,
      selectedBuildingClasses,
      propertyFilter,
      saleFilter,
      tags
    } = this.props;

    const appliedFilters = [];
    selectedBuildingClasses.forEach(buildingClass => appliedFilters.push(buildingClass));
    tags.forEach(tag => appliedFilters.push(tag));

    Object.keys(saleFilter).forEach((key) => {
      if (saleFilter[key] !== '' && key !== 'leaseRateUnits') {
        appliedFilters.push(saleFilter[key]);
      }
    });

    Object.keys(propertyFilter).forEach((key) => {
      if (propertyFilter[key] !== '' && key !== 'lotUnits') {
        appliedFilters.push(propertyFilter[key]);
      }
    });

    assetClasses.map((asset) => {
      if (this.isSelected(selectedAssetClasses, asset.value)) {
        appliedFilters.push(asset.label);
      }
    });

    availabilities.map((availability) => {
      if (this.isSelected(selectedAvailabilities, availability.value)) {
        appliedFilters.push(availability.label);
      }
    });

    return appliedFilters;
  }

  render() {
    const { onDisplayFilters } = this.props;
    const appliedFilters = this.appliedFilters();

    return (
      <div className="visible-xs visible-sm">
        <div className="filters-row mobile-filters-row">
          {appliedFilters.length > 0 ?
            <button className="filters-text" onClick={onDisplayFilters}>
              <div className="filters-count">{appliedFilters.length}</div>
              <strong>Filters:</strong>
              <span className="applied-filters-text">{ appliedFilters.join(", ")}</span>
            </button>
            : <button className="filters-text" onClick={onDisplayFilters}>
              <FontAwesomeIcon
                className="right-buffer-sm"
                icon={faFilter}
              />
              Filters
              <FontAwesomeIcon
                className="left-buffer-sm"
                icon={faAngleDown}
              />
            </button>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  assetClasses: state.static.assetClasses,
  availabilities: state.static.availabilities,
  saleFilter: state.query.saleFilter,
  selectedAvailabilities: state.query.availabilities,
  selectedAssetClasses: state.query.assetClasses,
  selectedBuildingClasses: state.query.buildingClasses,
  propertyFilter: state.query.propertyFilter,
  tags: state.query.tags,
});

export default connect(mapStateToProps, {})(MobileFilterTopBar);
